﻿import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Aidant} from '../_models';
import { config } from '../../assets/config';
import {getToken} from '../../assets/utils.js';

@Injectable()
export class AidantService {
    constructor(private http: HttpClient) {}

    getByUserId(id: string) {
        return this.http.get(`${config.apiUrl}/aidants?filter={"include":["patient"],"where":{"userId":"${id}"}}&access_token: ${getToken()}`);
    }

    getByPatientId(id: string) {
        return this.http.get(`${config.apiUrl}/patients/` + id + '/aidants?filter={"include":["user"]}&access_token: ${getToken()}');
    }

    getByKeyAndBirthday(key: string, birthday: string) {
        return this.http.get(`${config.apiUrl}/aidants?filter={"include":{"relation":"patient","scope":{"where":{"birthday":"${birthday}"}}},"where":{"key":"${key}","associated":{"neq":true}}}&access_token: ${getToken()}`);
    }

    register(aidant: Aidant) {
        return this.http.post(`${config.apiUrl}/aidants`, aidant, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    registerByPatientId(patientId: string, aidant: Aidant) {
        return this.http.post(`${config.apiUrl}/patients/` + patientId + '/aidants', aidant, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    assignUserAsAidant(userId: string, aidantId: string) {
        const data = {
            userId,
            associated: true
        }
        return this.http.patch(
            `${config.apiUrl}/aidants/` + aidantId,
            data,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
            }
        );
    }
}
